import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

export function AuthLayout() {
  const { session } = useAuthStore()
  if (session) return <Navigate to="/terminal" replace />
  return (
    <div className="flex items-center justify-center h-full bg-bb-bg">
      <Outlet />
    </div>
  )
}
